var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"col-lg-6 col-md-12 text-center"},[_c('ah-reviews')],1),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('ah-notes')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }